import React, { useState, useEffect } from "react";
import NavbarDev, { loadNav } from "./Navbar";
import { useNavigate } from "react-router-dom";
import Table from "../../components/Table";
import PopUp from "../../components/PopUp";
import Combobox from "../../components/Combobox";
import Input from "../../components/Input";
import Checkbox from "../../components/Checkbox";
import Loader from "../../components/Loader";
import Tooltip from "../../components/Tooltip";
import Alert from "../../components/Alert";
import Button from "../../components/Button";
import { useDeviceLayout } from "../../components/DeviceLayoutProvider";
import { Upload, Trash2, SquarePen, Info } from "lucide-react";
import * as XLSX from 'xlsx';

const RowPC = ({ data, onCheckboxChange, piani, setShowAlert, setAlertInfo }) => {
    const [isInfoDominioVisible, setIsInfoDominioVisible] = useState(false);
    const [infoDominio, setInfoDominio] = useState({});

    useEffect(() => {
        const loadInfoDominio = async () => {
            try {
                const r = await fetch('/getDominio', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ CodiceDominio: data.value.CodiceDominio })
                });
                const rd = await r.json();
                if (r.status === 500) {
                    console.log(rd.error);
                    setAlertInfo({ type: "error", text: rd.error, onClose: () => { window.location.reload(); } });
                    setShowAlert(true);
                }
                else {
                    setInfoDominio(rd[0]);
                }
            } catch (error) {
                console.error(error);
                setAlertInfo({ type: "error", text: "Errore nel caricamento delle informazioni del dominio", onClose: () => { setShowAlert(false) } });
                setShowAlert(true);
            }
        };

        isInfoDominioVisible && loadInfoDominio();
    }, [isInfoDominioVisible]);

    return (
        <div className="flex flex-row">
            <div onClick={(e) => e.stopPropagation()} className="flex items-center justify-center">
                <Checkbox
                    checked={data.checked}
                    onChange={() => onCheckboxChange(data.value.ID)}
                    size={18}
                />
            </div>
            <div className="grid grid-cols-7 py-4 border-b-2 border-gray-300 dark:border-neutral-700 w-full">
                <div className="flex items-center pl-2 ">
                    {data.value.CodiceAttivazione}
                </div>
                <Tooltip text={piani.find((d) => d.ID === data.value.IDPiano)?.Descrizione || ""} position="t" delay={200}>
                    <div className="flex items-center pl-2 underline hover:cursor-pointer">
                        {piani.find((d) => d.ID === data.value.IDPiano)?.Nome}
                    </div>
                </Tooltip>
                <div className="flex items-center pl-2 ">
                    {data.value.ValiditaMesi}
                </div>
                <div className="flex items-center pl-2 ">
                    {data.value.Venditore}
                </div>
                <div className="flex items-center pl-2 ">
                    {data.value.DataCreazione}
                </div>
                <div className="flex items-center pl-2 ">
                    {data.value.DataAttivazione}
                </div>
                <div
                    className={`flex items-center pl-2 ${data.value.CodiceDominio && ("text-blue-600 underline font-semibold hover:cursor-pointer no-row-action")}`}
                    onClick={(e) => {
                        if (!data.value.CodiceDominio) return;
                        setIsInfoDominioVisible(true);
                        e.stopPropagation();
                    }}
                >
                    {data.value.CodiceDominio}
                </div>
            </div>
            <PopUp title={"Informazioni Dominio"}
                isVisible={isInfoDominioVisible}
                setIsVisible={setIsInfoDominioVisible}
                needConfirm={false}
            >
                <div className="flex flex-col items-center">
                    <div className="w-[80%] md:w-[70%] mt-3">
                        <p className="flex justify-between">
                            Codice/P.iva :
                            <span className="font-semibold">{infoDominio["CodiceDominio"]}</span>
                        </p>
                        <p className="flex justify-between mt-1">
                            Ragione Sociale :
                            <span className="font-semibold">{infoDominio["RagioneSociale"]}</span>
                        </p>
                        <p className="flex justify-between mt-1">
                            Indirizzo :
                            <span className="font-semibold">{infoDominio["Indirizzo"]}</span>
                        </p>
                        <p className="flex justify-between mt-1">
                            Città :
                            <span className="font-semibold">{infoDominio["Citta"]}</span>
                        </p>
                        <p className="flex justify-between mt-1">
                            CAP :
                            <span className="font-semibold">{infoDominio["Cap"]}</span>
                        </p>
                        <p className="flex justify-between mt-1">
                            Provincia :
                            <span className="font-semibold">{infoDominio["Provincia"]}</span>
                        </p>
                    </div>
                </div>
            </PopUp>
        </div>
    );
};

const RowMobile = ({ data, headers, keyForPreview, piani }) => {
    return (
        <>
            {
                headers.map(header => (
                    !keyForPreview.includes(header.key) && (
                        <div key={`mobile-detail-${header.key}`} className="mb-2">
                            <span className="font-medium text-sm text-gray-500 dark:text-gray-400">
                                {header.label}:
                            </span>
                            <span className="ml-1 text-sm">
                                {header.key === 'IDPiano' ? ` ${piani.find((p) => p.ID === data.value[header.key])?.Nome}` : (data.value[header.key])}
                            </span>
                        </div>
                    )
                ))
            }
        </>
    );
};

const Dash = () => {
    const { isLittle } = useDeviceLayout();
    const headers = [
        { label: 'Codice', key: 'CodiceAttivazione' },
        { label: 'Piano', key: 'IDPiano' },
        { label: 'Validità (mesi)', key: 'ValiditaMesi' },
        { label: 'Venditore', key: 'Venditore' },
        { label: 'Data creazione', key: 'DataCreazione' },
        { label: 'Data attivazione', key: 'DataAttivazione' },
        { label: 'Dominio', key: 'CodiceDominio' },
    ];
    const [dataTable, setDataTable] = useState([]);
    const [dataAdd, setDataAdd] = useState({
        "Quantita": null,
        "IDPiano": null,
        "ValiditaMesi": null,
        "Venditore": ""
    });
    const [dataRow, setDataRow] = useState({});
    const [isAddVisible, setIsAddVisible] = useState(false);
    const [isRowInfoVisible, setIsRowInfoVisible] = useState(false);
    const [needConfirmRow, setNeedConfirmRow] = useState(false);
    const [isInfoDominioVisible, setIsInfoDominioVisible] = useState(false);
    const [piani, setPiani] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [infoDominio, setInfoDominio] = useState({});
    const navigate = useNavigate();
    const [showAlert, setShowAlert] = useState(false);
    const [alertInfo, setAlertInfo] = useState({ type: "info", text: "", onClose: () => setShowAlert(false), needConfirm: false, onConfirm: () => { } });

    useEffect(() => {
        const loadInfoDominio = async () => {
            try {
                const r = await fetch('/getDominio', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ CodiceDominio: dataRow.CodiceDominio })
                });
                const rd = await r.json();
                if (r.status === 500) {
                    console.log(rd.error);
                    setAlertInfo({ type: "error", text: rd.error, onClose: () => { window.location.reload(); }, needConfirm: false });
                    setShowAlert(true);
                }
                else {
                    setInfoDominio(rd[0]);
                }
            } catch (error) {
                console.error(error);
                setAlertInfo({ type: "error", text: "Errore nel caricamento delle informazioni del dominio", onClose: () => { setShowAlert(false) }, needConfirm: false });
                setShowAlert(true);
            }
        };
        if (isInfoDominioVisible) {
            loadInfoDominio();
        }
    }, [isInfoDominioVisible]);

    useEffect(() => {
        onload();
    }, []);

    const onload = async () => {
        setIsLoading(true);
        await loadNav();
        try {
            const r1 = await fetch('/getPiani', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            const rd1 = await r1.json();
            if (r1.status === 500) {
                console.log(rd1.error);
                setAlertInfo({ type: "error", text: rd1.error, onClose: () => { navigate('/') }, needConfirm: false });
                setShowAlert(true);
            }
            else {
                setPiani(rd1);
            }
        } catch (error) {
            console.error(error);
            setAlertInfo({ type: "error", text: "Errore nel caricamento dei piani", onClose: () => { navigate('/'); }, needConfirm: false });
            setShowAlert(true);
        }
        try {
            const r2 = await fetch('/getLicenze', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            const rd2 = await r2.json();
            if (r2.status === 500) {
                console.log(rd2.error);
                setAlertInfo({ type: "error", text: rd2.error, onClose: () => { window.location.reload(); }, needConfirm: false });
                setShowAlert(true);
            }
            else {
                setDataTable(rd2.map(item => ({ value: item, checked: false })));
            }
        } catch (error) {
            console.error(error);
            setAlertInfo({ type: "error", text: "Errore nel caricamento delle licenze", onClose: () => { window.location.reload(); }, needConfirm: false });
            setShowAlert(true);
        }
        setIsLoading(false);
    };

    const handleExport = () => {
        const dataChecked = dataTable.filter((d) => d.checked);
        if (dataChecked.length === 0) return;

        const dataSheet = dataChecked.map(d => ({
            CodiceAttivazione: d.value["CodiceAttivazione"],
            Piano: piani.find((p) => p.ID === d.value["IDPiano"]).Nome,
            ValiditaMesi: d.value["ValiditaMesi"],
            Venditore: d.value["Venditore"],
            DataCreazione: d.value["DataCreazione"],
            DataAttivazione: d.value["DataAttivazione"],
            Dominio: d.value["CodiceDominio"]
        }));
        const worksheet = XLSX.utils.json_to_sheet(dataSheet);
        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(workbook, worksheet, "Foglio1");

        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = "Export.xlsx";
        link.click();
        window.URL.revokeObjectURL(url);
    };

    const handleElimina = async () => {
        const pass = async () => {
            setIsLoading(true);
            try {
                const r = await fetch('/eliminaLicenza', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ ID: dataRow.ID })
                });

                if (r.status === 200) {
                    window.location.reload(true);
                }
                else {
                    const rd = await r.json();
                    console.log(rd.error);
                    setAlertInfo({ type: "error", text: rd.error, onClose: () => { setShowAlert(false) }, needConfirm: false });
                    setShowAlert(true);
                }
            } catch (error) {
                console.log(error);
                setAlertInfo({ type: "error", text: "Operazione fallita, riprova più tardi.", onClose: () => { setShowAlert(false) }, needConfirm: false });
                setShowAlert(true);
            }
            setIsLoading(false);
        };
        setAlertInfo({ type: "warning", text: "Sei sicuro di voler eliminare questa licenza?", onClose: () => { setShowAlert(false) }, needConfirm: true, onConfirm: pass });
        setShowAlert(true);
    };

    const confirmPopUpModifica = async () => {
        if (dataRow.IDPiano === null || dataRow.ValiditaMesi === 0 || dataRow.Venditore === "") {
            setAlertInfo({ type: "warning", text: "Compilare tutti i campi", onClose: () => { setShowAlert(false) }, needConfirm: false });
            setShowAlert(true);
            return;
        };

        setIsLoading(true);

        try {
            const r = await fetch('/aggiornaLicenza', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ ID: dataRow.ID, Piano: Number(dataRow.IDPiano), Validita: Number(dataRow.ValiditaMesi), Venditore: dataRow.Venditore })
            });

            if (r.status === 500) {
                const rd = await r.json();
                console.log(rd.error);
                setAlertInfo({ type: "error", text: rd.error, onClose: () => { setShowAlert(false) }, needConfirm: false });
                setShowAlert(true);
            } else {
                setIsLoading(false);
                window.location.reload(true);
            }
        } catch (error) {
            console.error(error);
            setAlertInfo({ type: "error", text: "Errore nell'aggiornamento della licenza, riprova più tardi.", onClose: () => { window.location.reload(true); }, needConfirm: false });
            setShowAlert(true);
        }
        setIsLoading(false);
    };

    const confirmPopUpAdd = async () => {
        if (!dataAdd.Quantita || !dataAdd.IDPiano || !dataAdd.ValiditaMesi || !dataAdd.Venditore) {
            setAlertInfo({ type: "warning", text: "Compilare tutti i campi obbligatori (*)", onClose: () => { setShowAlert(false) }, needConfirm: false });
            setShowAlert(true);
            return;
        };

        setIsLoading(true);

        try {
            const r = await fetch('/addLicenza', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ Quantita: Number(dataAdd.Quantita), Piano: Number(dataAdd.IDPiano), Validita: Number(dataAdd.ValiditaMesi), Venditore: dataAdd.Venditore })
            });
            if (r.status === 500) {
                const rd = await r.json();
                console.log(rd.error);
                setAlertInfo({ type: "error", text: rd.error, onClose: () => { setShowAlert(false) }, needConfirm: false });
                setShowAlert(true);
            } else {
                setIsLoading(false);
                window.location.reload(true);
            }
        } catch (error) {
            console.error(error);
            setAlertInfo({ type: "error", text: "Errore nell'aggiunta della licenza, riprova più tardi.", onClose: () => { setShowAlert(false) }, needConfirm: false });
            setShowAlert(true);
        }

        setIsLoading(false);
    };

    return (
        <div className="h-[100svh]">
            <NavbarDev page={"DASH"} />
            {isLoading && <Loader />}
            {showAlert && <Alert type={alertInfo.type} text={alertInfo.text} onClose={alertInfo.onClose} needConfirm={alertInfo.needConfirm} onConfirm={alertInfo.onConfirm} />}
            <div className="h-[93%] overflow-y-auto px-4">
                <Table
                    headers={headers}
                    keyForPreview={["CodiceAttivazione", "CodiceDominio"]}
                    data={dataTable}
                    setData={setDataTable}
                    renderRowPC={({ rowData, handleRowCheckboxChange }) => <RowPC data={rowData} onCheckboxChange={handleRowCheckboxChange} piani={piani} setShowAlert={setShowAlert} setAlertInfo={setAlertInfo} />}
                    renderRowMobile={({ rowData, headers, keyForPreview }) => <RowMobile data={rowData} headers={headers} keyForPreview={keyForPreview} piani={piani} />}
                    itemsPC={9}
                    itemsMobile={7}
                    needResearch={true}
                    specialFilter={[
                        { key: 'IDPiano', values: piani.map(p => ({ value: p.ID, label: p.Nome })) }
                    ]}
                    clickableRow={true}
                    archiveClickable={false}
                    actionRow={(row, rowIndex, showArchived) => {
                        setIsRowInfoVisible(true); setDataRow(row.value); setNeedConfirmRow(false);
                    }}
                    classes="mt-2"
                    needCheckbox={true}
                    renderButtonForCheckbox={() =>
                        <Button type='hollow' onClick={handleExport}>
                            EXPORT <Upload size={20} className="inline-block ml-1" />
                        </Button>
                    }
                    needAdd={true}
                    addAction={() => setIsAddVisible(true)}
                    needArchive={true}
                    archiveKey="Obsoleta"
                    archiveValue={true}
                />
                <PopUp title={needConfirmRow ? "Modifica licenza" : ""}
                    isVisible={isRowInfoVisible}
                    setIsVisible={setIsRowInfoVisible}
                    needConfirm={needConfirmRow}
                    confirmAction={confirmPopUpModifica}
                    cancelAction={() => { setNeedConfirmRow(false); setDataRow({}); }}
                >
                    {needConfirmRow && (
                        <div className="flex flex-col items-center">
                            <Combobox
                                options={piani.map(p => ({ value: p.ID, label: p.Nome }))}
                                onChange={(value) => setDataRow({ ...dataRow, IDPiano: value })}
                                label="Piano"
                                classes="w-[80%] md:w-[70%] mt-2"
                                disabled={!needConfirmRow}
                                error={false}
                                readOnly={false}
                                defaultValue={dataRow.IDPiano}
                            />
                            <Input
                                label="Descrizione piano"
                                value={piani.find(p => p.ID === dataRow.IDPiano)?.Descrizione || ""}
                                setValue={() => { }}
                                type="text"
                                classes="w-[80%] md:w-[70%] mt-2"
                                disabled={true}
                                error={false}
                            />
                            <Input
                                label="Validità (mesi)"
                                value={dataRow.ValiditaMesi || ""}
                                setValue={(value) => setDataRow({ ...dataRow, ValiditaMesi: value })}
                                type="number"
                                classes="w-[80%] md:w-[70%] mt-2"
                                disabled={!needConfirmRow}
                                error={false}
                            />
                            <Input
                                label="Venditore"
                                value={dataRow.Venditore || ""}
                                setValue={(value) => setDataRow({ ...dataRow, Venditore: value })}
                                type="text"
                                classes="w-[80%] md:w-[70%] mt-2"
                                disabled={!needConfirmRow}
                                error={false}
                            />
                        </div>
                    )}
                    {!needConfirmRow && (
                        <>
                            <div className="grid grid-cols-2 gap-2 mt-2">
                                <Button type='hollow' onClick={handleElimina}>
                                    ELIMINA <Trash2 size={16} strokeWidth={2} className="inline-block ml-1" />
                                </Button>
                                <Button type='hollow' onClick={() => setNeedConfirmRow(true)}>
                                    MODIFICA <SquarePen size={16} strokeWidth={2} className="inline-block ml-1" />
                                </Button>
                            </div>
                            {
                                isLittle && (
                                    <div className="flex items-center justify-center mt-2">
                                        <Button type='hollow' onClick={() => setIsInfoDominioVisible(true)}>
                                            INFO DOMINIO <Info size={16} strokeWidth={2} className="inline-block ml-1" />
                                        </Button>
                                        <PopUp
                                            title={"Informazioni Dominio"}
                                            isVisible={isInfoDominioVisible}
                                            setIsVisible={setIsInfoDominioVisible}
                                            needConfirm={false}
                                        >
                                            <div className="flex flex-col items-center">
                                                <div className="w-[80%] md:w-[70%] mt-3">
                                                    <p className="flex justify-between">
                                                        Codice/P.iva :
                                                        <span className="font-semibold">{infoDominio["CodiceDominio"]}</span>
                                                    </p>
                                                    <p className="flex justify-between mt-1">
                                                        Ragione Sociale :
                                                        <span className="font-semibold">{infoDominio["RagioneSociale"]}</span>
                                                    </p>
                                                    <p className="flex justify-between mt-1">
                                                        Indirizzo :
                                                        <span className="font-semibold">{infoDominio["Indirizzo"]}</span>
                                                    </p>
                                                    <p className="flex justify-between mt-1">
                                                        Città :
                                                        <span className="font-semibold">{infoDominio["Citta"]}</span>
                                                    </p>
                                                    <p className="flex justify-between mt-1">
                                                        CAP :
                                                        <span className="font-semibold">{infoDominio["Cap"]}</span>
                                                    </p>
                                                    <p className="flex justify-between mt-1">
                                                        Provincia :
                                                        <span className="font-semibold">{infoDominio["Provincia"]}</span>
                                                    </p>
                                                </div>
                                            </div>
                                        </PopUp>
                                    </div>
                                )
                            }
                        </>
                    )}
                </PopUp>
                <PopUp title={"Aggiungi licenza"}
                    isVisible={isAddVisible}
                    setIsVisible={setIsAddVisible}
                    needConfirm={true}
                    confirmAction={confirmPopUpAdd}
                    cancelAction={() => { setIsAddVisible(false); setDataAdd({}); }}
                >
                    <div className="flex flex-col items-center">
                        <Input
                            label="Quantità *"
                            value={dataAdd.Quantita || ""}
                            setValue={(value) => setDataAdd({ ...dataAdd, Quantita: value })}
                            type="number"
                            classes="w-[80%] md:w-[70%] mt-2"
                            disabled={false}
                            error={false}
                        />
                        <Combobox
                            options={piani.map(p => ({ value: p.ID, label: p.Nome }))}
                            onChange={(value) => setDataAdd({ ...dataAdd, IDPiano: value })}
                            label="Piano *"
                            classes="w-[80%] md:w-[70%] mt-2"
                            disabled={false}
                            error={false}
                            readOnly={false}
                            defaultValue={dataAdd.IDPiano}
                        />
                        <Input
                            label="Descrizione piano"
                            value={piani.find(p => p.ID === dataAdd.IDPiano)?.Descrizione || ""}
                            setValue={() => { }}
                            type="text"
                            classes="w-[80%] md:w-[70%] mt-2"
                            disabled={true}
                            error={false}
                        />
                        <Input
                            label="Validità (mesi) *"
                            value={dataAdd.ValiditaMesi || ""}
                            setValue={(value) => setDataAdd({ ...dataAdd, ValiditaMesi: value })}
                            type="number"
                            classes="w-[80%] md:w-[70%] mt-2"
                            disabled={false}
                            error={false}
                        />
                        <Input
                            label="Venditore *"
                            value={dataAdd.Venditore || ""}
                            setValue={(value) => setDataAdd({ ...dataAdd, Venditore: value })}
                            type="text"
                            classes="w-[80%] md:w-[70%] mt-2"
                            disabled={false}
                            error={false}
                        />
                    </div>
                </PopUp>
            </div>
        </div>
    )
};

export default Dash;